export default "__VITE_ASSET__BTtmNw0o__"